export default __webpack_public_path__ + "static/media/sector 2.d8647574.jpg";